// extracted by mini-css-extract-plugin
export default {"actions":"c40a038720cbb82f","action":"_2ba3cd093c6f33e8"};